import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Container } from "@/components/Primitives";

export default function NotFound() {
    return (
        <>
            <Seo title="Page not found" />
            <Container className="flex min-h-[60vh] flex-col items-center justify-center py-24 text-center">
                <span className="font-mono text-5xl text-rule">404</span>
                <h1 className="mt-6 text-2xl font-semibold text-text-hi sm:text-3xl">
                    Off the line.
                </h1>
                <p className="mt-3 max-w-md text-text-lo">
                    This page isn't on the line. Let's get you back to where the
                    standard holds.
                </p>
                <Link
                    to="/"
                    data-testid="notfound-home-link"
                    className="btn-amber mt-8 rounded px-6 py-3 text-sm font-semibold"
                >
                    Back to home
                </Link>
            </Container>
        </>
    );
}
